import { map } from "rxjs";
import { Offer } from "../../model";
import apiService from "../ApiService";

const passSubscribeOffer = (offer: Offer, cancelUrl?: URL) => {
  // This API auth is made via the token in the body
  return apiService
    .post<{ checkoutSessionUrl: string }>({
      path: "public/store/stripe/checkout_session_offer",
      crm: true,
      requiresAuthPolicy: null as any, // no auth
      body: {
        offerUuid: offer.uuid,
        cancelUrl: cancelUrl?.toString(),
        token: apiService.userToken?.accessToken,
      },
    })
    .pipe(map((e) => e.checkoutSessionUrl));
};
export { passSubscribeOffer };
